<template>
  <div class="page-container">
    <PageHeader title="用户管理" show-breadcrumb>
      <template #actions>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">新增用户</el-button>
      </template>
    </PageHeader>

    <!-- 搜索面板 -->
    <SearchPanel>
      <el-input v-model.trim="query.auName" placeholder="用户名称" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-input v-model.trim="query.auAccount" placeholder="账号" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-select v-model="query.auPost" placeholder="岗位" clearable size="small">
        <el-option label="管理员" :value="1" />
        <el-option label="用户" :value="2" />
      </el-select>
      <template #actions>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
      </template>
    </SearchPanel>

    <!-- 表格 -->
    <TablePanel title="用户列表">
      <el-table :data="list" v-loading="loading" size="small" stripe border>
        <el-table-column type="index" label="序号" width="80" align="center" />
        <el-table-column prop="auName" label="姓名" min-width="120" />
        <el-table-column prop="auAccount" label="账号" min-width="140" />
        <el-table-column prop="auPostName" label="岗位" width="110" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.auPost === 1 ? 'danger' : 'info'" size="mini">{{ row.auPostName || (row.auPost === 1 ? '管理员' : '用户') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createtime" label="创建时间" width="180" />
        <el-table-column label="操作" width="220" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" size="mini" @click="handleResetPw(row)">重置密码</el-button>
            <el-button type="text" size="mini" class="text-danger" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </TablePanel>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogType === 'add' ? '新增用户' : '编辑用户'" :visible.sync="dialogVisible" width="500px" v-dialog-drag-resize>
      <el-form ref="formRef" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="姓名" prop="auName">
          <el-input v-model.trim="form.auName" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="账号" prop="auAccount">
          <el-input v-model.trim="form.auAccount" placeholder="请输入账号" :disabled="dialogType === 'edit'" />
        </el-form-item>
        <el-form-item v-if="dialogType === 'add'" label="密码" prop="auPw">
          <el-input v-model.trim="form.auPw" placeholder="不填默认123456" show-password />
        </el-form-item>
        <el-form-item label="岗位" prop="auPost">
          <el-select v-model="form.auPost" placeholder="请选择岗位" style="width:100%">
            <el-option label="管理员" :value="1" />
            <el-option label="用户" :value="2" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="submitting" @click="handleSubmit">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import SearchPanel from '@/components/SearchPanel.vue'
import TablePanel from '@/components/TablePanel.vue'
import { getAjefUserList, addAjefUser, updateAjefUser, updateAjefUserPw, deleteAjefUser } from '@/api/api'

export default {
  name: 'SystemUser',
  components: { PageHeader, SearchPanel, TablePanel },
  data () {
    return {
      loading: false,
      submitting: false,
      list: [],
      query: { auName: '', auAccount: '', auPost: null },
      page: { currentPage: 1, pageSize: 10, total: 0 },
      dialogVisible: false,
      dialogType: 'add',
      form: { auName: '', auAccount: '', auPw: '', auPost: 2 },
      rules: {
        auName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        auAccount: [{ required: true, message: '请输入账号', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.fetchList()
  },
  methods: {
    async fetchList () {
      this.loading = true
      try {
        const res = await getAjefUserList({
          ...this.query,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        })
        this.list = res.data || []
        this.page.total = res.total || 0
      } catch (e) {
        this.list = []
        this.page.total = 0
      } finally {
        this.loading = false
      }
    },
    handleSearch () { this.page.currentPage = 1; this.fetchList() },
    handleReset () {
      this.query = { auName: '', auAccount: '', auPost: null }
      this.handleSearch()
    },
    handleSizeChange (size) { this.page.pageSize = size; this.handleSearch() },
    handlePageChange (page) { this.page.currentPage = page; this.fetchList() },
    handleAdd () {
      this.dialogType = 'add'
      this.form = { auName: '', auAccount: '', auPw: '', auPost: 2 }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    handleEdit (row) {
      this.dialogType = 'edit'
      this.form = { auId: row.auId, auName: row.auName, auAccount: row.auAccount, auPost: row.auPost }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    handleSubmit () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          if (this.dialogType === 'add') {
            await addAjefUser(this.form)
            this.$message.success('新增成功')
          } else {
            await updateAjefUser(this.form)
            this.$message.success('编辑成功')
          }
          this.dialogVisible = false
          this.fetchList()
        } catch (e) {} finally {
          this.submitting = false
        }
      })
    },
    async handleResetPw (row) {
      await this.$confirm(`确认将用户「${row.auName}」的密码重置为 123456？`, '重置密码', { type: 'warning' })
      try {
        await updateAjefUserPw({ auPw: '123456' })
        this.$message.success('密码已重置为 123456')
      } catch (e) {}
    },
    async handleDelete (row) {
      await this.$confirm(`确认删除用户「${row.auName}」？`, '提示', { type: 'warning' })
      try {
        await deleteAjefUser({ auId: row.auId })
        this.$message.success('删除成功')
        this.fetchList()
      } catch (e) {}
    }
  }
}
</script>
